export default "__VITE_ASSET__Dj7jyfAx__ 100w";